(function () {
  const store = window.ScrubLabTeams.store;

    // LOAD EXISTING PRODUCT EMBROIDERY CUSTOMISER
  store.fetchEmbroideryCustomiser = async function (productHandle) {
    const response = await fetch(
      `/products/${encodeURIComponent(productHandle)}`
    );

    if (!response.ok) {
      throw new Error('Unable to load embroidery customiser');
    }

    const html = await response.text();
    const documentFragment = new DOMParser().parseFromString(
      html,
      'text/html'
    );

    const customiser = documentFragment.querySelector(
      '#scrublab-customiser'
    );

    if (!customiser) return null;

    customiser.removeAttribute('id');

    return customiser;
  };

  // OPEN PRODUCT DRAWER
  store.openDrawer = async function (productHandle) {
    store.state.drawer.isOpen = true;
    store.state.drawer.productHandle = productHandle;
    store.state.drawer.product = null;

    store.els.drawer.hidden = false;
    document.documentElement.style.overflow = 'hidden';

    store.els.drawerContent.innerHTML = `
      <div class="team-builder__loading">
        <div class="team-builder__spinner"></div>
        <p>Loading product...</p>
      </div>
    `;

    try {
      const product = await store.fetchProduct(productHandle);

      // Ignore the response if the drawer was closed
      // or another product was opened in the meantime.
      if (
        !store.state.drawer.isOpen ||
        store.state.drawer.productHandle !== productHandle
      ) {
        return;
      }

      store.state.drawer.product = product;

      store.state.drawer.selectedOptions = [
        ...store.getDefaultSelectedOptions(product)
      ];

      store.renderDrawer();

    } catch (error) {
      console.error('Bundle Builder product error:', error);

      if (
        !store.state.drawer.isOpen ||
        store.state.drawer.productHandle !== productHandle
      ) {
        return;
      }

      store.els.drawerContent.innerHTML = `
        <div class="team-builder__empty">
          <strong>Unable to load this product.</strong>
          <p>Please close the drawer and try again.</p>
        </div>
      `;
    }
  };

  // RENDER PRODUCT DRAWER
  store.renderDrawer = function () {
    const product = store.state.drawer.product;

    if (!product) return;

    const selectedOptions = store.state.drawer.selectedOptions;

    const selectedVariant = store.getVariantByOptions(
      product,
      selectedOptions
    );

    const isAvailable = Boolean(
      selectedVariant && selectedVariant.available
    );

    const price = selectedVariant
      ? store.money(selectedVariant.price)
      : '';

    // Escape text inserted into HTML
    const escapeHTML = (value) => {
      return String(value ?? '').replace(/[&<>"']/g, (character) => {
        const characters = {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        };

        return characters[character];
      });
    };

    const image = product.featured_image
      ? `<img
          src="${escapeHTML(product.featured_image)}"
          alt="${escapeHTML(product.title)}"
        >`
      : '';

    store.els.drawerContent.innerHTML = `
      <div class="team-builder__drawer-product">

        ${image}

        <div>
          <p class="team-builder__eyebrow">
            Build your bundle
          </p>

          <h2>${escapeHTML(product.title)}</h2>

          <p>${price}</p>
        </div>

      </div>

      ${store.getProductOptionsMarkup(product, selectedOptions)}

      <div
        class="team-builder__embroidery"
        data-bundle-embroidery
      ></div>

      <button
        type="button"
        class="team-builder__button"
        data-add-real-product
        ${isAvailable ? '' : 'disabled'}
      >
        ${isAvailable ? 'Add to Bundle' : 'Unavailable'}
      </button>
    `;

    store.loadDrawerEmbroidery();
  };

  // LOAD EMBROIDERY INTO DRAWER
  store.loadDrawerEmbroidery = async function () {
    const productHandle = store.state.drawer.productHandle;
    const container = store.els.drawerContent.querySelector(
      '[data-bundle-embroidery]'
    );

    if (!container || !productHandle) return;

    container.textContent = 'Loading embroidery options...';

    try {
      const customiser = await store.fetchEmbroideryCustomiser(
        productHandle
      );

      // Prevent stale requests from modifying a different product.
      if (
        !store.state.drawer.isOpen ||
        store.state.drawer.productHandle !== productHandle ||
        !container.isConnected
      ) {
        return;
      }

      container.replaceChildren();

      if (!customiser) return;

      container.appendChild(customiser);

      if (window.ScrubLabCustomiser?.init) {
        window.ScrubLabCustomiser.init(customiser);
      }

    } catch (error) {
      console.error('Bundle embroidery error:', error);

      if (container.isConnected) {
        container.textContent =
          'Embroidery options could not be loaded.';
      }
    }
  };

  // CLOSE PRODUCT DRAWER
  store.closeDrawer = function () {
    store.state.drawer.isOpen = false;
    store.state.drawer.productHandle = null;
    store.state.drawer.product = null;
    store.state.drawer.selectedOptions = [];

    store.els.drawer.hidden = true;

    document.documentElement.style.overflow = '';
  };
})();